import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { Tea } from '@/adapter/libs';
var sendTeaLog = Tea.sendTeaLog;
export var PageNameEnum = /*#__PURE__*/function (PageNameEnum) {
  PageNameEnum["CreatorMarketplace"] = "affiliate_find_creators";
  PageNameEnum["CreatorDetail"] = "affiliate_creator_details";
  PageNameEnum["FindMCNPage"] = "mcn_list";
  PageNameEnum["FindMCNProfile"] = "mcn_profile";
  PageNameEnum["CreatorLeaderboard"] = "creator_leaderboard";
  PageNameEnum["CollectionCreatorList"] = "collection_creator_list";
  PageNameEnum["TargetInvitationList"] = "target_invitation_list";
  PageNameEnum["TargetInvitationSelectCreate"] = "invitation_comparison";
  PageNameEnum["TargetInvitationForm"] = "affiliate_target_invitation";
  PageNameEnum["TargetInvitationCreate"] = "target_invitation_create";
  PageNameEnum["TargetInvitationEdit"] = "target_invitation_edit";
  PageNameEnum["TargetInvitationDetail"] = "target_invitation_detail_page";
  PageNameEnum["TargetInvitationCampaign"] = "affiliate_target_invitation_campaign";
  PageNameEnum["TargetInvitationCampaignCreate"] = "campaign_create";
  PageNameEnum["TargetInvitationCampaignEdit"] = "campaign_edit";
  PageNameEnum["TargetInvitationCampaignDetail"] = "campaign_detail";
  PageNameEnum["SellerIM"] = "seller_im";
  PageNameEnum["CreatorManagement"] = "affiliate_crm";
  PageNameEnum["CreatorManagementBulkIm"] = "affiliate_crm_batch_im";
  PageNameEnum["QuotaRuleOverview"] = "affiliate_connection_rule";
  PageNameEnum["QuotaStaterPackRule"] = "affiliate_connection_rule_starter";
  PageNameEnum["FlatFeeDetail"] = "flat_fee_detail";
  PageNameEnum["FlatFeeCreate"] = "flat_fee_create";
  return PageNameEnum;
}({});
export var EnterMethodEnum = /*#__PURE__*/function (EnterMethodEnum) {
  EnterMethodEnum["DIRECT_INVITE_CREATOR"] = "target_invite";
  EnterMethodEnum["BATCH_INVITE_CREATORS"] = "batch_invite_confirm";
  EnterMethodEnum["DUPLICATE"] = "duplicate";
  EnterMethodEnum["EDIT_INVITATION_DETAILS"] = "edit_collaboration_details";
  EnterMethodEnum["EDIT_CREATORS"] = "edit_creators";
  EnterMethodEnum["EDIT_PRODUCTS"] = "edit_products";
  EnterMethodEnum["EDIT_FREE_SAMPLE"] = "edit_sample_request";
  EnterMethodEnum["EDIT_CAMPAIGN_PRODUCTS"] = "edit_campaign_products";
  return EnterMethodEnum;
}({});
export var TrackParamKeyEnum = /*#__PURE__*/function (TrackParamKeyEnum) {
  TrackParamKeyEnum["PageName"] = "page_name";
  TrackParamKeyEnum["ClickFor"] = "click_for";
  TrackParamKeyEnum["EnterFrom"] = "enter_from";
  TrackParamKeyEnum["QuotaStatus"] = "quota_status";
  return TrackParamKeyEnum;
}({});
export var TrackEventNameEnum = /*#__PURE__*/function (TrackEventNameEnum) {
  TrackEventNameEnum["AFFILIATE_PAGE_SHOW"] = "affiliate_page_show";
  TrackEventNameEnum["AFFILIATE_BUTTON_CLICK"] = "affiliate_button_click";
  return TrackEventNameEnum;
}({});
export var Track = /*#__PURE__*/function () {
  function Track(_ref) {
    var _objectSpread2;
    var pageName = _ref.pageName,
      extraCommonParams = _ref.extraCommonParams;
    this.commonParams = {};
    this.addCommonParams(_objectSpread((_objectSpread2 = {}, _objectSpread2[TrackParamKeyEnum.PageName] = pageName, _objectSpread2), extraCommonParams));
  }
  var _proto = Track.prototype;
  _proto.addCommonParams = function addCommonParams(trackParams) {
    Object.assign(this.commonParams, trackParams);
  };
  _proto.sendLog = function sendLog(_ref2) {
    var eventName = _ref2.eventName,
      extraParams = _ref2.extraParams;
    sendTeaLog(eventName, _objectSpread(_objectSpread({}, this.commonParams), extraParams));
  };
  return Track;
}();